// src/features/auth/amplify-api.ts (your ./api)
import {
    getCurrentUser,
    fetchUserAttributes,
    updateUserAttributes,
    signOut,
    type UpdateUserAttributesInput,
} from "aws-amplify/auth";
import type { AmplifyAttributes, AmplifyCurrentUser, IUserInfo } from "./types";

export async function loadCurrentUser(): Promise<AmplifyCurrentUser> {
    const { userId, username } = await getCurrentUser();
    return { userId, username };
}

export async function loadAttributes(): Promise<AmplifyAttributes> {
    return await fetchUserAttributes();
}

export async function saveAttributes(
    attrs: UpdateUserAttributesInput["userAttributes"]
) {
    // attrs example: { given_name: "John", family_name: "Doe" }
    return await updateUserAttributes({ userAttributes: attrs });
}

export async function loadUserInfo(): Promise<IUserInfo> {
    const [{ userId, username }, attrs] = await Promise.all([
        getCurrentUser(),
        fetchUserAttributes(),
    ]);
    return { user: { userId, username }, attrs };
}

export async function doSignOut() {
    await signOut();
}
